import React from "react";

export const VuesaxBulkShieldTick = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="64"
      viewBox="0 0 64 64"
      width="64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.2268 5.49338L14.5601 10.9867C11.7601 12.0534 9.4668 15.3601 9.4668 18.3734V39.9734C9.4668 42.1334 10.8801 44.9867 12.6135 46.2667L27.2801 57.2267C29.8668 59.1734 34.1068 59.1734 36.6935 57.2267L51.3601 46.2667C53.0935 44.96 54.5068 42.1334 54.5068 39.9734V18.3734C54.5068 15.3867 52.2135 12.0534 49.4135 11.0134L34.7468 5.52005C33.2535 4.93338 30.7468 4.93338 29.2268 5.49338Z"
        fill="url(#paint0_linear_12_3587)"
        opacity="0.4"
      />

      <path
        d="M28.4268 37.9467C27.9201 37.9467 27.4135 37.76 27.0135 37.36L22.7201 33.0667C21.9468 32.2934 21.9468 31.0134 22.7201 30.24C23.4935 29.4667 24.7735 29.4667 25.5468 30.24L28.4268 33.12L38.4801 23.0667C39.2535 22.2934 40.5335 22.2934 41.3068 23.0667C42.0801 23.84 42.0801 25.12 41.3068 25.8934L29.8401 37.36C29.4401 37.76 28.9335 37.9467 28.4268 37.9467Z"
        fill="url(#paint1_linear_12_3587)"
      />

      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_12_3587"
          x1="9.4668"
          x2="54.5068"
          y1="31.8817"
          y2="31.8817"
        >
          <stop stopColor="#FF6EB3" />

          <stop offset="0.471154" stopColor="#AA81FF" />

          <stop offset="1" stopColor="#6BC9FF" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_12_3587"
          x1="22.1401"
          x2="41.8868"
          y1="30.2167"
          y2="30.2167"
        >
          <stop stopColor="#FF6EB3" />

          <stop offset="0.471154" stopColor="#AA81FF" />

          <stop offset="1" stopColor="#6BC9FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
